import { createTheme } from '@mui/material/styles';

const PRIMARY_COLOR = '#00a76f';
const SECONDARY_COLOR = '#0c53b7';
const BACKGROUND_COLOR = '#f6f9fc';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: PRIMARY_COLOR,
      light: '#5ce1b9',
      dark: '#007054'
    },
    secondary: {
      main: SECONDARY_COLOR
    },
    background: {
      default: BACKGROUND_COLOR,
      paper: '#ffffff'
    },
    divider: '#e5e8eb',
    text: {
      primary: '#111927',
      secondary: '#6b7280'
    }
  },
  typography: {
    fontFamily: '"Public Sans", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 700,
      letterSpacing: '-0.02em'
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.01em'
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: 0
    },
    body1: {
      fontSize: 14.75,
      lineHeight: 1.57
    },
    body2: {
      fontSize: 13.5,
      lineHeight: 1.57
    }
  },
  shape: {
    borderRadius: 18
  },
  shadows: [
    'none',
    '0px 1px 2px rgba(15, 23, 42, 0.06)',
    '0px 4px 10px rgba(15, 23, 42, 0.05)',
    '0px 8px 20px rgba(15, 23, 42, 0.08)',
    ...new Array(22).fill('0px 12px 24px rgba(15, 23, 42, 0.08)')
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: BACKGROUND_COLOR,
          color: '#111927'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          boxShadow: '0px 4px 12px rgba(15, 23, 42, 0.04)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // borderRadius: 24,
          boxShadow: '0px 24px 64px rgba(15, 23, 42, 0.08)'
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid #eef2f6',
          background: '#ffffff'
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 16,
          paddingRight: 16,
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 167, 111, 0.08)',
            color: PRIMARY_COLOR,
            '& .MuiListItemIcon-root': {
              color: PRIMARY_COLOR
            }
          }
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#f1f5f9',
          '& .MuiTableCell-root': {
            fontWeight: 600,
            textTransform: 'uppercase',
            fontSize: 12,
            color: '#475569'
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: '#eef2f6',
          fontSize: 13.5
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 600,
          fontSize: 12,
          paddingLeft: 4,
          paddingRight: 4
        }
      }
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained'
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 20,
          paddingRight: 20
        }
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: '1px solid #eef2f6'
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 24
        }
      }
    }
  }
});

export default theme;
